const discounts = {
    variable_1: '#1',
    init() {
        this.events();
    },
    events() {
        /**
         * Execute events
         */
        this.executeSlick();
    },    
    executeSlick() {
        jQuery('.discounts-slider').slick(
            {
                dots: true,
                infinite: true,
                speed: 500,
                cssEase: 'linear',
                autoplay: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        );
    },
};
jQuery(() => {
    discounts.init();
});